/*
 * Copyright (C) Fraunhofer IESE 2021-2025 - Mher Ter-Tovmasyan
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

const requestTypeEn = {
  municipality: "Municipality",
  solutionProvider: "Solution Provider",
  publicAuthorities: "Public Authority",
};

export const requestsPageEn = {
  requests: "Requests",
  registerRequests: "Registration Requests",
  description: "Keep track of registration requests.",
  name: "Name",
  type: "Type",
  statusLabel: "Status",
  lastUpdated: "Last Updated",
  empty: {
    top: "There are currently no registration requests.",
    bottom:
      "Here you will find all requests from municipalities, solution providers, and other public authorities who want to become part of {{appName}}.",
  },
  info: {
    title: "About Registration Requests",
    content: {
      title: "What are registration requests?",
      message:
        "Registration requests are requests from municipalities, solution providers, and other public authorities who want to become part of {{appName}}.",
    },
  },
  requestType: requestTypeEn,
  status: {
    PENDING: "Open",
    CREATED: "Accepted",
    REJECTED: "Rejected",
  },
  detail: {
    title: "Request about {{name}}",
    description: "Edit Registration Request",
    comment: "Internal Comments",
    history: "History:",
    noComments: "no comments available",
    save: "Save Changes",
    requestType: requestTypeEn,
    handle: {
      title: "Edit Request",
      note: "Comment or Justification",
      save: "Note that changes made will be automatically applied before rejecting or accepting the request!",
      placeholder:
        "Justify the decision about registration on the {{appName}} marketplace",
      info: "This justification will be sent to the applicants!",
      reject: "Reject",
      accept: "Accept",
      handled: "Request already processed: {{status}}",
      accepted: "accepted.",
      rejected: "rejected.",
    },
  },
};
